<template>
    <tr class="offer-row" :class="isText ? 'offer-row-text' : null">
        <td>
            <v-checkbox v-model="isText" @change="setType" class="pl-4 pt-0 mt-0" hide-details/>
        </td>
        <td :colspan="isText ? 5 : 1">
            <v-text-field v-model="value.text" label="Tekst" hide-details style="width: 100%"
                          placeholder="Beskrivelse"/>
        </td>
        <td v-if="!isText">
            <v-text-field v-model="value.count" type="number" step="1" label="Antall" hide-details
                          style="width: 120px"/>
        </td>
        <td v-if="!isText">
            <v-text-field v-model="value.unit" label="Enhet" hide-details size="3"/>
        </td>
        <td v-if="!isText">
            <v-text-field v-model="value.price" type="number" label="Pris per enhet" hide-details style="width: 120px">
                <template v-slot:prepend>kr</template>
            </v-text-field>
        </td>
        <td v-if="!isText" style="width: 150px" class="text-right">{{ formatMoney(sum) }}</td>
        <td class="text-no-wrap px-1">
            <v-btn icon title="Ny linje før" @click="emitAdd">
                <v-icon color="green">add</v-icon>
            </v-btn>
            <v-btn icon title="Fjern linje" @click="emitRemove">
                <v-icon color="red">remove</v-icon>
            </v-btn>
        </td>
    </tr>
</template>

<script>
    import {formatMoney} from "../../helpers";

    export default {
        props: {
            value: Object
        },

        methods: {
            formatMoney,
            emitAdd() {
                this.$emit('addBefore', this.value);
            },
            emitRemove() {
                this.$emit('remove', this.value);
            },
            setType() {
                if (this.isText) {
                    this.value.type = 'product';
                } else {
                    this.value.type = 'text';
                }
            }
        },

        watch: {
            sum(sum) {
                this.value.sum = sum;
            }
        },

        computed: {
            sum() {
                return this.value.count * this.value.price * (1 - this.value.discount / 100);
            },
            isText: {
                get() {
                    if (!this.value || !this.value.type) return false;
                    return this.value.type === 'text';
                },
                set(isText) {
                    // Noop. Handled in @change handler.
                }
            }
        }
    }
</script>

<style>
    .v-data-table .offer-row td {
        padding: 6px 12px 8px 12px !important;
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    .v-data-table .offer-row td:last-child {
        border-right: 0;
    }

    .v-data-table .offer-row-text td {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .v-data-table .offer-row .v-input__prepend-outer, .v-data-table .offer-row .v-input__append-inner {
        font-size: 80%;
        opacity: 0.6;
    }
</style>